import { format, type Locale, parseISO } from 'date-fns'

import { getPaxObDatepickerLocale } from '@dfds-pax/utils'

import { getUrlLocale } from './localeHelpers'

export const longDateFormat = (date?: string | null): string | null =>
  date ? format(parseISO(date), 'EEEE dd MMMM yyyy', { locale: getDatepickerLocale() }) : null

export const departureLegDateFormat = (date?: string | null): string | null =>
  date ? format(parseISO(date), 'EEE, d MMM, yyyy', { locale: getDatepickerLocale() }) : null

export const dayFormat = (date?: string | null): string | null =>
  date ? format(parseISO(date), 'EEEE', { locale: getDatepickerLocale() }) : null

export const extraLongDateFormat = (date?: string | null): string | null =>
  date ? format(parseISO(date), 'EEEE, dd MMMM yyyy', { locale: getDatepickerLocale() }) : null

export const shortDateFormat = (date?: string | undefined): string | undefined =>
  date ? format(parseISO(date), 'dd MMM yyyy', { locale: getDatepickerLocale() }) : undefined

export const standardDateFormat = (date?: string | undefined): string | undefined =>
  date ? format(parseISO(date), 'dd-MM-yyyy', { locale: getDatepickerLocale() }) : undefined

export const extraShortDateFormat = (date?: string | undefined): string | undefined =>
  date ? format(parseISO(date), 'dd MMM', { locale: getDatepickerLocale() }) : undefined

export const extractTime = (isoTime: string): string | undefined => isoTime?.match(/..:../)?.[0]

export const isDateInThePast = (date: string | null | undefined): boolean => {
  if (!date) return true
  const now = new Date().toISOString().substring(0, 10)
  return now > date // date is represented as utc
}

export const isDateTimeInThePast = (date: string | null | undefined): boolean => {
  if (!date) return true
  const now = new Date().toISOString()
  return now > date // date is represented as utc
}

export interface DatesData {
  dates: {
    fromDate: string
    toDate: string
  }
  defaultDate: string
  disabledDates: string[]
  offerDates: string[]
  offerText?: string
}

export function getDatepickerLocale(): Locale {
  return getPaxObDatepickerLocale(getUrlLocale())
}
